import type { Loader as RootLoader } from "../../root.tsx"

import { createLangHooks } from "@iyk/localization/client"

export const { useLang } = createLangHooks<RootLoader>()
